import React, { useState } from 'react'
import BreadcrumbComp from '@components/UI/Breadcrumb/Index.jsx'
import PageWrapper from '@components/UI/PageWrapper/Index';
import { useGenericReducer } from '@hooks/state/useGenericReducer';
import GridReportFormularios from '@components/Formulario/GridReport';
import FilterForms from '@components/Formulario/Filter';

const RelatorioFormularios = () => {
  const NomeForm = "Relatório de Formulários";
  const { state, setData } = useGenericReducer();

  const [filters, setFilters] = useState({
    tipoAssociacao: "",
    numeroSolicitacao: "",
    tituloFormulario: "",
    dataEnvioRespostaInicial: "",
    dataEnvioRespostaFinal: "",
    nomeUnidadeGerencia: "",
    nomeProcesso: "",
  });

  return (
    <PageWrapper>
      <div className="row">
        <BreadcrumbComp Param1="Home" Param2={"Relatórios e Indicadores"} Param3={NomeForm} />
        <div className="col-12 col-md-12">
          <div className="block h-auto">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12 col-md-6 d-flex align-items-center">
                  <h2 className="mb-0">{NomeForm}</h2>
                </div>
                <div className="col-12 col-md-6 d-flex align-items-center justify-content-end">
                  <button className="btn btn-menu">
                    <i className="fa-solid fa-bars"></i>
                  </button>
                </div>

                <div>
                  <FilterForms
                    setFilters={setFilters}
                  />
                </div>

                <div>
                  <GridReportFormularios
                    state={state}
                    setData={setData}
                    filters={filters}
                  />
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </PageWrapper>
  )
}

export default RelatorioFormularios;